import React, {useState, useEffect} from "react";
import "./style.scss";
import {useTranslation} from "react-i18next";
import Loader from "../Loader";

const ServiceType = ({services, handleServiceSelect, serviceAvailable}) => {
  const [wait, setWait] = useState(true);
  const {t} = useTranslation();

  useEffect(() => {
    setTimeout(() => {
      setWait(false);
    }, 1000);
  }, []);

  const availableServices = services?.filter((service) =>
    serviceAvailable.includes(service.serviceTypeId)
  );

  return (
    <>
      {wait ? (
        <div className="loader-container service-loader-container">
          <Loader />
        </div>
      ) : (
        <>
          {availableServices && availableServices.length ? (
            <div className="flex flex-col gap-4 w-full max-w-[406px] mt-2">
              {availableServices.map((service) => (
                <button
                  key={service.queueConfigId}
                  onClick={() => handleServiceSelect(service)}
                  className="w-full text-[#343E49] bg-white rounded-[12px] shadow-md py-6 text-lg font-bold text-center hover:bg-gray-100 transition-colors mt-2"
                >
                  {service.serviceType}
                </button>
              ))}
            </div>
          ) : (
            <div className="serviceType-notAvl">
              <div className="serviceType-notAvl-img"></div>
              <div className="serviceType-notAvl-text">
                {t("serviceNotAvailableMessage")}
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ServiceType;
